export const CountryCodeAndOtherData = 
[{
    "name": "Afghanistan",
    "dial_code": "+93",
    "emoji": "🇦🇫",
    "code": "AF"
},
{
    "name": "Aland Islands",
    "dial_code": "+358",
    "emoji": "🇦🇽",
    "code": "AX"
},
{
    "name": "Albania",
    "dial_code": "+355",
    "emoji": "🇦🇱",
    "code": "AL"
},
{
    "name": "Algeria",
    "dial_code": "+213",
    "emoji": "🇩🇿",
    "code": "DZ"
},
{
    "name": "AmericanSamoa",
    "dial_code": "+1684",
    "emoji": "🇦🇸",
    "code": "AS"
},
{
    "name": "Andorra",
    "dial_code": "+376",
    "emoji": "🇦🇩",
    "code": "AD"
},
{
    "name": "Angola",
    "dial_code": "+244",
    "emoji": "🇦🇴",
    "code": "AO"
},
{
    "name": "Anguilla",
    "dial_code": "+1264",
    "emoji": "🇦🇮",
    "code": "AI"
},
{
    "name": "Antarctica",
    "dial_code": "+672",
    "emoji": "🇦🇶",
    "code": "AQ"
},
{
    "name": "Antigua and Barbuda",
    "dial_code": "+1268",
    "emoji": "🇦🇬",
    "code": "AG"
},
{
    "name": "Argentina",
    "dial_code": "+54",
    "emoji": "🇦🇷",
    "code": "AR"
},
{
    "name": "Armenia",
    "dial_code": "+374",
    "emoji": "🇦🇲",
    "code": "AM"
},
{
    "name": "Aruba",
    "dial_code": "+297",
    "emoji": "🇦🇼",
    "code": "AW"
},
{
    "name": "Australia",
    "dial_code": "+61",
    "emoji": "🇦🇺",
    "code": "AU"
},
{
    "name": "Austria",
    "dial_code": "+43",
    "emoji": "🇦🇹",
    "code": "AT"
},
{
    "name": "Azerbaijan",
    "dial_code": "+994",
    "emoji": "🇦🇿",
    "code": "AZ"
},
{
    "name": "Bahamas",
    "dial_code": "+1242",
    "emoji": "🇧🇸",
    "code": "BS"
},
{
    "name": "Bahrain",
    "dial_code": "+973",
    "emoji": "🇧🇭",
    "code": "BH"
},
{
    "name": "Bangladesh",
    "dial_code": "+880",
    "emoji": "🇧🇩",
    "code": "BD"
},
{
    "name": "Barbados",
    "dial_code": "+1246",
    "emoji": "🇧🇧",
    "code": "BB"
},
{
    "name": "Belarus",
    "dial_code": "+375",
    "emoji": "🇧🇾",
    "code": "BY"
},
{
    "name": "Belgium",
    "dial_code": "+32",
    "emoji": "🇧🇪",
    "code": "BE"
},
{
    "name": "Belize",
    "dial_code": "+501",
    "emoji": "🇧🇿",
    "code": "BZ"
},
{
    "name": "Benin",
    "dial_code": "+229",
    "emoji": "🇧🇯",
    "code": "BJ"
},
{
    "name": "Bermuda",
    "dial_code": "+1441",
    "emoji": "🇧🇲",
    "code": "BM"
},
{
    "name": "Bhutan",
    "dial_code": "+975",
    "emoji": "🇧🇹",
    "code": "BT"
},
{
    "name": "Bolivia, Plurinational State of",
    "dial_code": "+591",
    "emoji": "🇧🇴",
    "code": "BO"
},
{
    "name": "Bosnia and Herzegovina",
    "dial_code": "+387",
    "emoji": "🇧🇦",
    "code": "BA"
},
{
    "name": "Botswana",
    "dial_code": "+267",
    "emoji": "🇧🇼",
    "code": "BW"
},
{
    "name": "Brazil",
    "dial_code": "+55",
    "emoji": "🇧🇷",
    "code": "BR"
},
{
    "name": "British Indian Ocean Territory",
    "dial_code": "+246",
    "emoji": "🇮🇴",
    "code": "IO"
},
{
    "name": "Brunei Darussalam",
    "dial_code": "+673",
    "emoji": "🇧🇳",
    "code": "BN"
},
{
    "name": "Bulgaria",
    "dial_code": "+359",
    "emoji": "🇧🇬",
    "code": "BG"
},
{
    "name": "Burkina Faso",
    "dial_code": "+226",
    "emoji": "🇧🇫",
    "code": "BF"
},
{
    "name": "Burundi",
    "dial_code": "+257",
    "emoji": "🇧🇮",
    "code": "BI"
},
{
    "name": "Cambodia",
    "dial_code": "+855",
    "emoji": "🇰🇭",
    "code": "KH"
},
{
    "name": "Cameroon",
    "dial_code": "+237",
    "emoji": "🇨🇲",
    "code": "CM"
},
{
    "name": "Canada",
    "dial_code": "+1",
    "emoji": "🇨🇦",
    "code": "CA"
},
{
    "name": "Cape Verde",
    "dial_code": "+238",
    "emoji": "🇨🇻",
    "code": "CV"
},
{
    "name": "Cayman Islands",
    "dial_code": "+345",
    "emoji": "🇰🇾",
    "code": "KY"
},
{
    "name": "Central African Republic",
    "dial_code": "+236",
    "emoji": "🇨🇫",
    "code": "CF"
},
{
    "name": "Chad",
    "dial_code": "+235",
    "emoji": "🇹🇩",
    "code": "TD"
},
{
    "name": "Chile",
    "dial_code": "+56",
    "emoji": "🇨🇱",
    "code": "CL"
},
{
    "name": "China",
    "dial_code": "+86",
    "emoji": "🇨🇳",
    "code": "CN"
},
{
    "name": "Christmas Island",
    "dial_code": "+61",
    "emoji": "🇨🇽",
    "code": "CX"
},
{
    "name": "Cocos (Keeling) Islands",
    "dial_code": "+61",
    "emoji": "🇨🇨",
    "code": "CC"
},
{
    "name": "Colombia",
    "dial_code": "+57",
    "emoji": "🇨🇴",
    "code": "CO"
},
{
    "name": "Comoros",
    "dial_code": "+269",
    "emoji": "🇰🇲",
    "code": "KM"
},
{
    "name": "Congo",
    "dial_code": "+242",
    "emoji": "🇨🇬",
    "code": "CG"
},
{
    "name": "Congo, The Democratic Republic of the Congo",
    "dial_code": "+243",
    "emoji": "🇨🇩",
    "code": "CD"
},
{
    "name": "Cook Islands",
    "dial_code": "+682",
    "emoji": "🇨🇰",
    "code": "CK"
},
{
    "name": "Costa Rica",
    "dial_code": "+506",
    "emoji": "🇨🇷",
    "code": "CR"
},
{
    "name": "Cote d'Ivoire",
    "dial_code": "+225",
    "emoji": "🇨🇮",
    "code": "CI"
},
{
    "name": "Croatia",
    "dial_code": "+385",
    "emoji": "🇭🇷",
    "code": "HR"
},
{
    "name": "Cuba",
    "dial_code": "+53",
    "emoji": "🇨🇺",
    "code": "CU"
},
{
    "name": "Cyprus",
    "dial_code": "+357",
    "emoji": "🇨🇾",
    "code": "CY"
},
{
    "name": "Czech Republic",
    "dial_code": "+420",
    "emoji": "🇨🇿",
    "code": "CZ"
},
{
    "name": "Denmark",
    "dial_code": "+45",
    "emoji": "🇩🇰",
    "code": "DK"
},
{
    "name": "Djibouti",
    "dial_code": "+253",
    "emoji": "🇩🇯",
    "code": "DJ"
},
{
    "name": "Dominica",
    "dial_code": "+1767",
    "emoji": "🇩🇲",
    "code": "DM"
},
{
    "name": "Dominican Republic",
    "dial_code": "+1849",
    "emoji": "🇩🇴",
    "code": "DO"
},
{
    "name": "Ecuador",
    "dial_code": "+593",
    "emoji": "🇪🇨",
    "code": "EC"
},
{
    "name": "Egypt",
    "dial_code": "+20",
    "emoji": "🇪🇬",
    "code": "EG"
},
{
    "name": "El Salvador",
    "dial_code": "+503",
    "emoji": "🇸🇻",
    "code": "SV"
},
{
    "name": "Equatorial Guinea",
    "dial_code": "+240",
    "emoji": "🇬🇶",
    "code": "GQ"
},
{
    "name": "Eritrea",
    "dial_code": "+291",
    "emoji": "🇪🇷",
    "code": "ER"
},
{
    "name": "Estonia",
    "dial_code": "+372",
    "emoji": "🇪🇪",
    "code": "EE"
},
{
    "name": "Ethiopia",
    "dial_code": "+251",
    "emoji": "🇪🇹",
    "code": "ET"
},
{
    "name": "Falkland Islands (Malvinas)",
    "dial_code": "+500",
    "emoji": "🇫🇰",
    "code": "FK"
},
{
    "name": "Faroe Islands",
    "dial_code": "+298",
    "emoji": "🇫🇴",
    "code": "FO"
},
{
    "name": "Fiji",
    "dial_code": "+679",
    "emoji": "🇫🇯",
    "code": "FJ"
},
{
    "name": "Finland",
    "dial_code": "+358",
    "emoji": "🇫🇮",
    "code": "FI"
},
{
    "name": "France",
    "dial_code": "+33",
    "emoji": "🇫🇷",
    "code": "FR"
},
{
    "name": "French Guiana",
    "dial_code": "+594",
    "emoji": "🇬🇫",
    "code": "GF"
},
{
    "name": "French Polynesia",
    "dial_code": "+689",
    "emoji": "🇵🇫",
    "code": "PF"
},
{
    "name": "Gabon",
    "dial_code": "+241",
    "emoji": "🇬🇦",
    "code": "GA"
},
{
    "name": "Gambia",
    "dial_code": "+220",
    "emoji": "🇬🇲",
    "code": "GM"
},
{
    "name": "Georgia",
    "dial_code": "+995",
    "emoji": "🇬🇪",
    "code": "GE"
},
{
    "name": "Germany",
    "dial_code": "+49",
    "emoji": "🇩🇪",
    "code": "DE"
},
{
    "name": "Ghana",
    "dial_code": "+233",
    "emoji": "🇬🇭",
    "code": "GH"
},
{
    "name": "Gibraltar",
    "dial_code": "+350",
    "emoji": "🇬🇮",
    "code": "GI"
},
{
    "name": "Greece",
    "dial_code": "+30",
    "emoji": "🇬🇷",
    "code": "GR"
},
{
    "name": "Greenland",
    "dial_code": "+299",
    "emoji": "🇬🇱",
    "code": "GL"
},
{
    "name": "Grenada",
    "dial_code": "+1473",
    "emoji": "🇬🇩",
    "code": "GD"
},
{
    "name": "Guadeloupe",
    "dial_code": "+590",
    "emoji": "🇬🇵",
    "code": "GP"
},
{
    "name": "Guam",
    "dial_code": "+1671",
    "emoji": "🇬🇺",
    "code": "GU"
},
{
    "name": "Guatemala",
    "dial_code": "+502",
    "emoji": "🇬🇹",
    "code": "GT"
},
{
    "name": "Guernsey",
    "dial_code": "+44-1481",
    "emoji": "🇬🇬",
    "code": "GG"
},
{
    "name": "Guinea",
    "dial_code": "+224",
    "emoji": "🇬🇳",
    "code": "GN"
},
{
    "name": "Guinea-Bissau",
    "dial_code": "+245",
    "emoji": "🇬🇼",
    "code": "GW"
},
{
    "name": "Guyana",
    "dial_code": "+595",
    "emoji": "🇬🇾",
    "code": "GY"
},
{
    "name": "Haiti",
    "dial_code": "+509",
    "emoji": "🇭🇹",
    "code": "HT"
},
{
    "name": "Holy See (Vatican City State)",
    "dial_code": "+379",
    "emoji": "🇻🇦",
    "code": "VA"
},
{
    "name": "Honduras",
    "dial_code": "+504",
    "emoji": "🇭🇳",
    "code": "HN"
},
{
    "name": "Hong Kong",
    "dial_code": "+852",
    "emoji": "🇭🇰",
    "code": "HK"
},
{
    "name": "Hungary",
    "dial_code": "+36",
    "emoji": "🇭🇺",
    "code": "HU"
},
{
    "name": "Iceland",
    "dial_code": "+354",
    "emoji": "🇮🇸",
    "code": "IS"
},
{
    "name": "India",
    "dial_code": "+91",
    "emoji": "🇮🇳",
    "code": "IN"
},
{
    "name": "Indonesia",
    "dial_code": "+62",
    "emoji": "🇮🇩",
    "code": "ID"
},
{
    "name": "Iran, Islamic Republic of Persian Gulf",
    "dial_code": "+98",
    "emoji": "🇮🇷",
    "code": "IR"
},
{
    "name": "Iraq",
    "dial_code": "+964",
    "emoji": "🇮🇷",
    "code": "IQ"
},
{
    "name": "Ireland",
    "dial_code": "+353",
    "emoji": "🇮🇪",
    "code": "IE"
},
{
    "name": "Isle of Man",
    "dial_code": "+44-1624",
    "emoji": "🇮🇲",
    "code": "IM"
},
{
    "name": "Israel",
    "dial_code": "+972",
    "emoji": "🇮🇱",
    "code": "IL"
},
{
    "name": "Italy",
    "dial_code": "+39",
    "emoji": "🇮🇹",
    "code": "IT"
},
{
    "name": "Jamaica",
    "dial_code": "+1876",
    "emoji": "🇯🇲",
    "code": "JM"
},
{
    "name": "Japan",
    "dial_code": "+81",
    "emoji": "🇯🇵",
    "code": "JP"
},
{
    "name": "Jersey",
    "dial_code": "+44-1534",
    "emoji": "🇯🇪",
    "code": "JE"
},
{
    "name": "Jordan",
    "dial_code": "+962",
    "emoji": "🇯🇴",
    "code": "JO"
},
{
    "name": "Kazakhstan",
    "dial_code": "+77",
    "emoji": "🇰🇿",
    "code": "KZ"
},
{
    "name": "Kenya",
    "dial_code": "+254",
    "emoji": "🇰🇪",
    "code": "KE"
},
{
    "name": "Kiribati",
    "dial_code": "+686",
    "emoji": "🇰🇮",
    "code": "KI"
},
{
    "name": "Korea, Democratic People's Republic of Korea",
    "dial_code": "+850",
    "emoji": "🇰🇵",
    "code": "KP"
},
{
    "name": "Korea, Republic of South Korea",
    "dial_code": "+82",
    "emoji": "🇰🇷",
    "code": "KR"
},
{
    "name": "Kuwait",
    "dial_code": "+965",
    "emoji": "🇰🇼",
    "code": "KW"
},
{
    "name": "Kyrgyzstan",
    "dial_code": "+996",
    "emoji": "🇰🇬",
    "code": "KG"
},
{
    "name": "Laos",
    "dial_code": "+856",
    "emoji": "🇱🇦",
    "code": "LA"
},
{
    "name": "Latvia",
    "dial_code": "+371",
    "emoji": "🇱🇻",
    "code": "LV"
},
{
    "name": "Lebanon",
    "dial_code": "+961",
    "emoji": "🇱🇧",
    "code": "LB"
},
{
    "name": "Lesotho",
    "dial_code": "+266",
    "emoji": "🇱🇸",
    "code": "LS"
},
{
    "name": "Liberia",
    "dial_code": "+231",
    "emoji": "🇱🇷",
    "code": "LR"
},
{
    "name": "Libyan Arab Jamahiriya",
    "dial_code": "+218",
    "emoji": "🇱🇾",
    "code": "LY"
},
{
    "name": "Liechtenstein",
    "dial_code": "+423",
    "emoji": "🇱🇮",
    "code": "LI"
},
{
    "name": "Lithuania",
    "dial_code": "+370",
    "emoji": "🇱🇹",
    "code": "LT"
},
{
    "name": "Luxembourg",
    "dial_code": "+352",
    "emoji": "🇱🇺",
    "code": "LU"
},
{
    "name": "Macao",
    "dial_code": "+853",
    "emoji": "🇲🇴",
    "code": "MO"
},
{
    "name": "Macedonia",
    "dial_code": "+389",
    "emoji": "🇲🇰",
    "code": "MK"
},
{
    "name": "Madagascar",
    "dial_code": "+261",
    "emoji": "🇲🇬",
    "code": "MG"
},
{
    "name": "Malawi",
    "dial_code": "+265",
    "emoji": "🇲🇼",
    "code": "MW"
},
{
    "name": "Malaysia",
    "dial_code": "+60",
    "emoji": "🇲🇾",
    "code": "MY"
},
{
    "name": "Maldives",
    "dial_code": "+960",
    "emoji": "🇲🇻",
    "code": "MV"
},
{
    "name": "Mali",
    "dial_code": "+223",
    "emoji": "🇲🇱",
    "code": "ML"
},
{
    "name": "Malta",
    "dial_code": "+356",
    "emoji": "🇲🇹",
    "code": "MT"
},
{
    "name": "Marshall Islands",
    "dial_code": "+692",
    "emoji": "🇲🇭",
    "code": "MH"
},
{
    "name": "Martinique",
    "dial_code": "+596",
    "emoji": "🇲🇶",
    "code": "MQ"
},
{
    "name": "Mauritania",
    "dial_code": "+222",
    "emoji": "🇲🇷",
    "code": "MR"
},
{
    "name": "Mauritius",
    "dial_code": "+230",
    "emoji": "🇲🇺",
    "code": "MU"
},
{
    "name": "Mayotte",
    "dial_code": "+262",
    "emoji": "🇾🇹",
    "code": "YT"
},
{
    "name": "Mexico",
    "dial_code": "+52",
    "emoji": "🇲🇽",
    "code": "MX"
},
{
    "name": "Micronesia, Federated States of Micronesia",
    "dial_code": "+691",
    "emoji": "🇫🇲",
    "code": "FM"
},
{
    "name": "Moldova",
    "dial_code": "+373",
    "emoji": "🇲🇩",
    "code": "MD"
},
{
    "name": "Monaco",
    "dial_code": "+377",
    "emoji": "🇲🇨",
    "code": "MC"
},
{
    "name": "Mongolia",
    "dial_code": "+976",
    "emoji": "🇲🇳",
    "code": "MN"
},
{
    "name": "Montenegro",
    "dial_code": "+382",
    "emoji": "🇲🇪",
    "code": "ME"
},
{
    "name": "Montserrat",
    "dial_code": "+1664",
    "emoji": "🇲🇸",
    "code": "MS"
},
{
    "name": "Morocco",
    "dial_code": "+212",
    "emoji": "🇲🇦",
    "code": "MA"
},
{
    "name": "Mozambique",
    "dial_code": "+258",
    "emoji": "🇲🇿",
    "code": "MZ"
},
{
    "name": "Myanmar",
    "dial_code": "+95",
    "emoji": "🇲🇲",
    "code": "MM"
},
{
    "name": "Namibia",
    "emoji": "🇳🇦",
    "dial_code": "+264",
    "code": "NA"
},
{
    "name": "Nauru",
    "dial_code": "+674",
    "emoji": "🇳🇷",
    "code": "NR"
},
{
    "name": "Nepal",
    "dial_code": "+977",
    "emoji": "🇳🇵",
    "code": "NP"
},
{
    "name": "Netherlands",
    "dial_code": "+31",
    "emoji": "🇳🇱",
    "code": "NL"
},
{
    "name": "Netherlands Antilles",
    "dial_code": "+599",
    "emoji": "🇧🇶",
    "code": "AN"
},
{
    "name": "New Caledonia",
    "dial_code": "+687",
    "emoji": "🇳🇨",
    "code": "NC"
},
{
    "name": "New Zealand",
    "dial_code": "+64",
    "emoji": "🇳🇿",
    "code": "NZ"
},
{
    "name": "Nicaragua",
    "dial_code": "+505",
    "emoji": "🇳🇮",
    "code": "NI"
},
{
    "name": "Niger",
    "dial_code": "+227",
    "emoji": "🇳🇪",
    "code": "NE"
},
{
    "name": "Nigeria",
    "dial_code": "+234",
    "emoji": "🇳🇬",
    "code": "NG"
},
{
    "name": "Niue",
    "dial_code": "+683",
    "emoji": "🇳🇺",
    "code": "NU"
},
{
    "name": "Norfolk Island",
    "dial_code": "+672",
    "emoji": "🇳🇫",
    "code": "NF"
},
{
    "name": "Northern Mariana Islands",
    "dial_code": "+1670",
    "emoji": "🇲🇵",
    "code": "MP"
},
{
    "name": "Norway",
    "dial_code": "+47",
    "emoji": "🇳🇴",
    "code": "NO"
},
{
    "name": "Oman",
    "dial_code": "+968",
    "emoji": "🇴🇲",
    "code": "OM"
},
{
    "name": "Pakistan",
    "dial_code": "+92",
    "emoji": "🇵🇰",
    "code": "PK"
},
{
    "name": "Palau",
    "dial_code": "+680",
    "emoji": "🇵🇼",
    "code": "PW"
},
{
    "name": "Palestinian Territory, Occupied",
    "dial_code": "+970",
    "emoji": "🇵🇸",
    "code": "PS"
},
{
    "name": "Panama",
    "dial_code": "+507",
    "emoji": "🇵🇦",
    "code": "PA"
},
{
    "name": "Papua New Guinea",
    "dial_code": "+675",
    "emoji": "🇵🇬",
    "code": "PG"
},
{
    "name": "Paraguay",
    "dial_code": "+595",
    "emoji": "🇵🇾",
    "code": "PY"
},
{
    "name": "Peru",
    "dial_code": "+51",
    "emoji": "🇵🇪",
    "code": "PE"
},
{
    "name": "Philippines",
    "dial_code": "+63",
    "emoji": "🇵🇭",
    "code": "PH"
},
{
    "name": "Pitcairn",
    "dial_code": "+872",
    "emoji": "🇵🇳",
    "code": "PN"
},
{
    "name": "Poland",
    "dial_code": "+48",
    "emoji": "🇵🇱",
    "code": "PL"
},
{
    "name": "Portugal",
    "dial_code": "+351",
    "emoji": "🇵🇹",
    "code": "PT"
},
{
    "name": "Puerto Rico",
    "dial_code": "+1939",
    "emoji": "🇵🇷",
    "code": "PR"
},
{
    "name": "Qatar",
    "dial_code": "+974",
    "emoji": "🇶🇦",
    "code": "QA"
},
{
    "name": "Romania",
    "dial_code": "+40",
    "emoji": "🇷🇴",
    "code": "RO"
},
{
    "name": "Russia",
    "dial_code": "+7",
    "emoji": "🇷🇺",
    "code": "RU"
},
{
    "name": "Rwanda",
    "dial_code": "+250",
    "emoji": "🇷🇼",
    "code": "RW"
},
{
    "name": "Reunion",
    "dial_code": "+262",
    "emoji": "🇷🇪",
    "code": "RE"
},
{
    "name": "Saint Barthelemy",
    "dial_code": "+590",
    "emoji": "🇧🇱",
    "code": "BL"
},
{
    "name": "Saint Helena, Ascension and Tristan Da Cunha",
    "dial_code": "+290",
    "emoji": "🇸🇭",
    "code": "SH"
},
{
    "name": "Saint Kitts and Nevis",
    "dial_code": "+1869",
    "emoji": "🇰🇳",
    "code": "KN"
},
{
    "name": "Saint Lucia",
    "dial_code": "+1758",
    "emoji": "🇱🇨",
    "code": "LC"
},
{
    "name": "Saint Martin",
    "dial_code": "+590",
    "emoji": "🇲🇫",
    "code": "MF"
},
{
    "name": "Saint Pierre and Miquelon",
    "dial_code": "+508",
    "emoji": "🇵🇲",
    "code": "PM"
},
{
    "name": "Saint Vincent and the Grenadines",
    "dial_code": "+1784",
    "emoji": "🇻🇨",
    "code": "VC"
},
{
    "name": "Samoa",
    "dial_code": "+685",
    "emoji": "🇼🇸",
    "code": "WS"
},
{
    "name": "San Marino",
    "dial_code": "+378",
    "emoji": "🇸🇲",
    "code": "SM"
},
{
    "name": "Sao Tome and Principe",
    "dial_code": "+239",
    "emoji": "🇸🇹",
    "code": "ST"
},
{
    "name": "Saudi Arabia",
    "dial_code": "+966",
    "emoji": "🇸🇦",
    "code": "SA"
},
{
    "name": "Senegal",
    "dial_code": "+221",
    "emoji": "🇸🇳",
    "code": "SN"
},
{
    "name": "Serbia",
    "dial_code": "+381",
    "emoji": "🇷🇸",
    "code": "RS"
},
{
    "name": "Seychelles",
    "dial_code": "+248",
    "emoji": "🇸🇨",
    "code": "SC"
},
{
    "name": "Sierra Leone",
    "dial_code": "+232",
    "emoji": "🇸🇱",
    "code": "SL"
},
{
    "name": "Singapore",
    "dial_code": "+65",
    "emoji": "🇸🇬",
    "code": "SG"
},
{
    "name": "Slovakia",
    "dial_code": "+421",
    "emoji": "🇸🇰",
    "code": "SK"
},
{
    "name": "Slovenia",
    "dial_code": "+386",
    "emoji": "🇸🇮",
    "code": "SI"
},
{
    "name": "Solomon Islands",
    "dial_code": "+677",
    "emoji": "🇸🇧",
    "code": "SB"
},
{
    "name": "Somalia",
    "dial_code": "+252",
    "emoji": "🇸🇴",
    "code": "SO"
},
{
    "name": "South Africa",
    "dial_code": "+27",
    "emoji": "🇿🇦",
    "code": "ZA"
},
{
    "name": "South Sudan",
    "dial_code": "+211",
    "emoji": "🇸🇸",
    "code": "SS"
},
{
    "name": "South Georgia and the South Sandwich Islands",
    "dial_code": "+500",
    "emoji": "🇬🇸",
    "code": "GS"
},
{
    "name": "Spain",
    "dial_code": "+34",
    "emoji": "🇪🇸",
    "code": "ES"
},
{
    "name": "Sri Lanka",
    "dial_code": "+94",
    "emoji": "🇱🇰",
    "code": "LK"
},
{
    "name": "Sudan",
    "dial_code": "+249",
    "emoji": "🇸🇩",
    "code": "SD"
},
{
    "name": "Suriname",
    "dial_code": "+597",
    "emoji": "🇸🇷",
    "code": "SR"
},
{
    "name": "Svalbard and Jan Mayen",
    "dial_code": "+47",
    "emoji": "🇸🇯",
    "code": "SJ"
},
{
    "name": "Swaziland",
    "dial_code": "+268",
    "emoji": "🇸🇿",
    "code": "SZ"
},
{
    "name": "Sweden",
    "dial_code": "+46",
    "emoji": "🇸🇪",
    "code": "SE"
},
{
    "name": "Switzerland",
    "dial_code": "+41",
    "emoji": "🇨🇭",
    "code": "CH"
},
{
    "name": "Syrian Arab Republic",
    "dial_code": "+963",
    "emoji": "🇸🇾",
    "code": "SY"
},
{
    "name": "Taiwan",
    "dial_code": "+886",
    "emoji": "🇹🇼",
    "code": "TW"
},
{
    "name": "Tajikistan",
    "dial_code": "+992",
    "emoji": "🇹🇯",
    "code": "TJ"
},
{
    "name": "Tanzania, United Republic of Tanzania",
    "dial_code": "+255",
    "emoji": "🇹🇿",
    "code": "TZ"
},
{
    "name": "Thailand",
    "dial_code": "+66",
    "emoji": "🇹🇭",
    "code": "TH"
},
{
    "name": "Timor-Leste",
    "dial_code": "+670",
    "emoji": "🇹🇱",
    "code": "TL"
},
{
    "name": "Togo",
    "dial_code": "+228",
    "emoji": "🇹🇬",
    "code": "TG"
},
{
    "name": "Tokelau",
    "dial_code": "+690",
    "emoji": "🇹🇰",
    "code": "TK"
},
{
    "name": "Tonga",
    "dial_code": "+676",
    "emoji": "🇹🇴",
    "code": "TO"
},
{
    "name": "Trinidad and Tobago",
    "dial_code": "+1868",
    "emoji": "🇹🇹",
    "code": "TT"
},
{
    "name": "Tunisia",
    "dial_code": "+216",
    "emoji": "🇹🇳",
    "code": "TN"
},
{
    "name": "Turkey",
    "dial_code": "+90",
    "emoji": "🇹🇷",
    "code": "TR"
},
{
    "name": "Turkmenistan",
    "dial_code": "+993",
    "emoji": "🇹🇲",
    "code": "TM"
},
{
    "name": "Turks and Caicos Islands",
    "dial_code": "+1649",
    "emoji": "🇹🇨",
    "code": "TC"
},
{
    "name": "Tuvalu",
    "dial_code": "+688",
    "emoji": "🇹🇻",
    "code": "TV"
},
{
    "name": "Uganda",
    "dial_code": "+256",
    "emoji": "🇺🇬",
    "code": "UG"
},
{
    "name": "Ukraine",
    "dial_code": "+380",
    "emoji": "🇺🇦",
    "code": "UA"
},
{
    "name": "United Arab Emirates",
    "dial_code": "+971",
    "emoji": "🇦🇪",
    "code": "AE"
},
{
    "name": "United Kingdom",
    "dial_code": "+44",
    "emoji": "🇬🇧",
    "code": "GB"
},
{
    "name": "United States",
    "dial_code": "+1",
    "emoji": "🇺🇸",
    "code": "US"
},
{
    "name": "Uruguay",
    "dial_code": "+598",
    "emoji": "🇺🇾",
    "code": "UY"
},
{
    "name": "Uzbekistan",
    "dial_code": "+998",
    "emoji": "🇺🇿",
    "code": "UZ"
},
{
    "name": "Vanuatu",
    "dial_code": "+678",
    "emoji": "🇻🇺",
    "code": "VU"
},
{
    "name": "Venezuela, Bolivarian Republic of Venezuela",
    "dial_code": "+58",
    "emoji": "🇻🇪",
    "code": "VE"
},
{
    "name": "Vietnam",
    "dial_code": "+84",
    "emoji": "🇻🇳",
    "code": "VN"
},
{
    "name": "Virgin Islands, British",
    "dial_code": "+1284",
    "emoji": "🇻🇬",
    "code": "VG"
},
{
    "name": "Virgin Islands, U.S.",
    "dial_code": "+1340",
    "emoji": "🇻🇮",
    "code": "VI"
},
{
    "name": "Wallis and Futuna",
    "dial_code": "+681",
    "emoji": "🇼🇫",
    "code": "WF"
},
{
    "name": "Yemen",
    "dial_code": "+967",
    "emoji": "🇾🇪",
    "code": "YE"
},
{
    "name": "Zambia",
    "dial_code": "+260",
    "emoji": "🇿🇲",
    "code": "ZM"
},
{
    "name": "Zimbabwe",
    "dial_code": "+263",
    "emoji": "🇿🇼",
    "code": "ZW"
}
]
//[{ Name: 'Afghanistan', Code: 'AF', Timezone: 'Afghanistan Standard Time', UTC: 'UTC+04:30', MobileCode: '+93' }, { Name: 'Åland Islands', Code: 'AX', Timezone: 'FLE Standard Time', UTC: 'UTC+02:00', MobileCode: '+358-18' }, { Name: 'Albania', Code: 'AL', Timezone: 'Central Europe Standard Time', UTC: 'UTC+01:00', MobileCode: '+355' }, { Name: 'Algeria', Code: 'DZ', Timezone: 'W. Central Africa Standard Time', UTC: 'UTC+01:00', MobileCode: '+213' }, { Name: 'American Samoa', Code: 'AS', Timezone: 'UTC-11', UTC: 'UTC-11:00', MobileCode: '+1-684' }, { Name: 'Andorra', Code: 'AD', Timezone: 'W. Europe Standard Time', UTC: 'UTC+01:00', MobileCode: '+376' }, { Name: 'Angola', Code: 'AO', Timezone: 'W. Central Africa Standard Time', UTC: 'UTC+01:00', MobileCode: '+244' }, { Name: 'Anguilla', Code: 'AI', Timezone: 'SA Western Standard Time', UTC: 'UTC-04:00', MobileCode: '+1-264' }, { Name: 'Antarctica', Code: 'AQ', Timezone: 'Pacific SA Standard Time', UTC: 'UTC-03:00', MobileCode: '+' }, { Name: 'Antigua and Barbuda', Code: 'AG', Timezone: 'SA Western Standard Time', UTC: 'UTC-04:00', MobileCode: '+1-268' }, { Name: 'Argentina', Code: 'AR', Timezone: 'Argentina Standard Time', UTC: 'UTC-03:00', MobileCode: '+54' }, { Name: 'Armenia', Code: 'AM', Timezone: 'Caucasus Standard Time', UTC: 'UTC+04:00', MobileCode: '+374' }, { Name: 'Aruba', Code: 'AW', Timezone: 'SA Western Standard Time', UTC: 'UTC-04:00', MobileCode: '+297' }, { Name: 'Australia', Code: 'AU', Timezone: 'AUS Eastern Standard Time', UTC: 'UTC+10:00', MobileCode: '+61' }, { Name: 'Austria', Code: 'AT', Timezone: 'W. Europe Standard Time', UTC: 'UTC+01:00', MobileCode: '+43' }, { Name: 'Azerbaijan', Code: 'AZ', Timezone: 'Azerbaijan Standard Time', UTC: 'UTC+04:00', MobileCode: '+994' }, { Name: 'Bahamas, The', Code: 'BS', Timezone: 'Eastern Standard Time', UTC: 'UTC-05:00', MobileCode: '+1-242' }, { Name: 'Bahrain', Code: 'BH', Timezone: 'Arab Standard Time', UTC: 'UTC+03:00', MobileCode: '+973' }, { Name: 'Bangladesh', Code: 'BD', Timezone: 'Bangladesh Standard Time', UTC: 'UTC+06:00', MobileCode: '+880' }, { Name: 'Barbados', Code: 'BB', Timezone: 'SA Western Standard Time', UTC: 'UTC-04:00', MobileCode: '+1-246' }, { Name: 'Belarus', Code: 'BY', Timezone: 'Belarus Standard Time', UTC: 'UTC+03:00', MobileCode: '+375' }, { Name: 'Belgium', Code: 'BE', Timezone: 'Romance Standard Time', UTC: 'UTC+01:00', MobileCode: '+32' }, { Name: 'Belize', Code: 'BZ', Timezone: 'Central America Standard Time', UTC: 'UTC-06:00', MobileCode: '+501' }, { Name: 'Benin', Code: 'BJ', Timezone: 'W. Central Africa Standard Time', UTC: 'UTC+01:00', MobileCode: '+229' }, { Name: 'Bermuda', Code: 'BM', Timezone: 'Atlantic Standard Time', UTC: 'UTC-04:00', MobileCode: '+1-441' }, { Name: 'Bhutan', Code: 'BT', Timezone: 'Bangladesh Standard Time', UTC: 'UTC+06:00', MobileCode: '+975' }, { Name: 'Bolivarian Republic of Venezuela', Code: 'VE', Timezone: 'Venezuela Standard Time', UTC: 'UTC-04:30', MobileCode: '+58' }, { Name: 'Bolivia', Code: 'BO', Timezone: 'SA Western Standard Time', UTC: 'UTC-04:00', MobileCode: '+591' }, { Name: 'Bonaire, Sint Eustatius and Saba', Code: 'BQ', Timezone: 'SA Western Standard Time', UTC: 'UTC-04:00', MobileCode: '+599' }, { Name: 'Bosnia and Herzegovina', Code: 'BA', Timezone: 'Central European Standard Time', UTC: 'UTC+01:00', MobileCode: '+387' }, { Name: 'Botswana', Code: 'BW', Timezone: 'South Africa Standard Time', UTC: 'UTC+02:00', MobileCode: '+267' }, { Name: 'Bouvet Island', Code: 'BV', Timezone: 'UTC', UTC: 'UTC', MobileCode: '+' }, { Name: 'Brazil', Code: 'BR', Timezone: 'E. South America Standard Time', UTC: 'UTC-03:00', MobileCode: '+55' }, { Name: 'British Indian Ocean Territory', Code: 'IO', Timezone: 'Central Asia Standard Time', UTC: 'UTC+06:00', MobileCode: '+246' }, { Name: 'Brunei', Code: 'BN', Timezone: 'Singapore Standard Time', UTC: 'UTC+08:00', MobileCode: '+673' }, { Name: 'Bulgaria', Code: 'BG', Timezone: 'FLE Standard Time', UTC: 'UTC+02:00', MobileCode: '+359' }, { Name: 'Burkina Faso', Code: 'BF', Timezone: 'Greenwich Standard Time', UTC: 'UTC', MobileCode: '+226' }, { Name: 'Burundi', Code: 'BI', Timezone: 'South Africa Standard Time', UTC: 'UTC+02:00', MobileCode: '+257' }, { Name: 'Cabo Verde', Code: 'CV', Timezone: 'Cape Verde Standard Time', UTC: 'UTC-01:00', MobileCode: '+238' }, { Name: 'Cambodia', Code: 'KH', Timezone: 'SE Asia Standard Time', UTC: 'UTC+07:00', MobileCode: '+855' }, { Name: 'Cameroon', Code: 'CM', Timezone: 'W. Central Africa Standard Time', UTC: 'UTC+01:00', MobileCode: '+237' }, { Name: 'Canada', Code: 'CA', Timezone: 'Eastern Standard Time', UTC: 'UTC-05:00', MobileCode: '+1' }, { Name: 'Cayman Islands', Code: 'KY', Timezone: 'SA Pacific Standard Time', UTC: 'UTC-05:00', MobileCode: '+1-345' }, { Name: 'Central African Republic', Code: 'CF', Timezone: 'W. Central Africa Standard Time', UTC: 'UTC+01:00', MobileCode: '+236' }, { Name: 'Chad', Code: 'TD', Timezone: 'W. Central Africa Standard Time', UTC: 'UTC+01:00', MobileCode: '+235' }, { Name: 'Chile', Code: 'CL', Timezone: 'Pacific SA Standard Time', UTC: 'UTC-03:00', MobileCode: '+56' }, { Name: 'China', Code: 'CN', Timezone: 'China Standard Time', UTC: 'UTC+08:00', MobileCode: '+86' }, { Name: 'Christmas Island', Code: 'CX', Timezone: 'SE Asia Standard Time', UTC: 'UTC+07:00', MobileCode: '+61' }, { Name: 'Cocos (Keeling) Islands', Code: 'CC', Timezone: 'Myanmar Standard Time', UTC: 'UTC+06:30', MobileCode: '+61' }, { Name: 'Colombia', Code: 'CO', Timezone: 'SA Pacific Standard Time', UTC: 'UTC-05:00', MobileCode: '+57' }, { Name: 'Comoros', Code: 'KM', Timezone: 'E. Africa Standard Time', UTC: 'UTC+03:00', MobileCode: '+269' }, { Name: 'Congo', Code: 'CG', Timezone: 'W. Central Africa Standard Time', UTC: 'UTC+01:00', MobileCode: '+242' }, { Name: 'Congo (DRC)', Code: 'CD', Timezone: 'W. Central Africa Standard Time', UTC: 'UTC+01:00', MobileCode: '+243' }, { Name: 'Cook Islands', Code: 'CK', Timezone: 'Hawaiian Standard Time', UTC: 'UTC-10:00', MobileCode: '+682' }, { Name: 'Costa Rica', Code: 'CR', Timezone: 'Central America Standard Time', UTC: 'UTC-06:00', MobileCode: '+506' }, { Name: "Côte d'Ivoire", Code: 'CI', Timezone: 'Greenwich Standard Time', UTC: 'UTC', MobileCode: '+225' }, { Name: 'Croatia', Code: 'HR', Timezone: 'Central European Standard Time', UTC: 'UTC+01:00', MobileCode: '+385' }, { Name: 'Cuba', Code: 'CU', Timezone: 'Eastern Standard Time', UTC: 'UTC-05:00', MobileCode: '+53' }, { Name: 'Curaçao', Code: 'CW', Timezone: 'SA Western Standard Time', UTC: 'UTC-04:00', MobileCode: '+599' }, { Name: 'Cyprus', Code: 'CY', Timezone: 'E. Europe Standard Time', UTC: 'UTC+02:00', MobileCode: '+357' }, { Name: 'Czech Republic', Code: 'CZ', Timezone: 'Central Europe Standard Time', UTC: 'UTC+01:00', MobileCode: '+420' }, { Name: 'Democratic Republic of Timor-Leste', Code: 'TL', Timezone: 'Tokyo Standard Time', UTC: 'UTC+09:00', MobileCode: '+670' }, { Name: 'Denmark', Code: 'DK', Timezone: 'Romance Standard Time', UTC: 'UTC+01:00', MobileCode: '+45' }, { Name: 'Djibouti', Code: 'DJ', Timezone: 'E. Africa Standard Time', UTC: 'UTC+03:00', MobileCode: '+253' }, { Name: 'Dominica', Code: 'DM', Timezone: 'SA Western Standard Time', UTC: 'UTC-04:00', MobileCode: '+1-767' }, { Name: 'Dominican Republic', Code: 'DO', Timezone: 'SA Western Standard Time', UTC: 'UTC-04:00', MobileCode: '+1-809 and 1-829' }, { Name: 'Ecuador', Code: 'EC', Timezone: 'SA Pacific Standard Time', UTC: 'UTC-05:00', MobileCode: '+593' }, { Name: 'Egypt', Code: 'EG', Timezone: 'Egypt Standard Time', UTC: 'UTC+02:00', MobileCode: '+20' }, { Name: 'El Salvador', Code: 'SV', Timezone: 'Central America Standard Time', UTC: 'UTC-06:00', MobileCode: '+503' }, { Name: 'Equatorial Guinea', Code: 'GQ', Timezone: 'W. Central Africa Standard Time', UTC: 'UTC+01:00', MobileCode: '+240' }, { Name: 'Eritrea', Code: 'ER', Timezone: 'E. Africa Standard Time', UTC: 'UTC+03:00', MobileCode: '+291' }, { Name: 'Estonia', Code: 'EE', Timezone: 'FLE Standard Time', UTC: 'UTC+02:00', MobileCode: '+372' }, { Name: 'Ethiopia', Code: 'ET', Timezone: 'E. Africa Standard Time', UTC: 'UTC+03:00', MobileCode: '+251' }, { Name: 'Falkland Islands (Islas Malvinas)', Code: 'FK', Timezone: 'SA Eastern Standard Time', UTC: 'UTC-03:00', MobileCode: '+500' }, { Name: 'Faroe Islands', Code: 'FO', Timezone: 'GMT Standard Time', UTC: 'UTC', MobileCode: '+298' }, { Name: 'Fiji Islands', Code: 'FJ', Timezone: 'Fiji Standard Time', UTC: 'UTC+12:00', MobileCode: '+679' }, { Name: 'Finland', Code: 'FI', Timezone: 'FLE Standard Time', UTC: 'UTC+02:00', MobileCode: '+358' }, { Name: 'France', Code: 'FR', Timezone: 'Romance Standard Time', UTC: 'UTC+01:00', MobileCode: '+33' }, { Name: 'French Guiana', Code: 'GF', Timezone: 'SA Eastern Standard Time', UTC: 'UTC-03:00', MobileCode: '+594' }, { Name: 'French Polynesia', Code: 'PF', Timezone: 'Hawaiian Standard Time', UTC: 'UTC-10:00', MobileCode: '+689' }, { Name: 'French Southern and Antarctic Lands', Code: 'TF', Timezone: 'West Asia Standard Time', UTC: 'UTC+05:00', MobileCode: '+' }, { Name: 'Gabon', Code: 'GA', Timezone: 'W. Central Africa Standard Time', UTC: 'UTC+01:00', MobileCode: '+241' }, { Name: 'Gambia, The', Code: 'GM', Timezone: 'Greenwich Standard Time', UTC: 'UTC', MobileCode: '+220' }, { Name: 'Georgia', Code: 'GE', Timezone: 'Georgian Standard Time', UTC: 'UTC+04:00', MobileCode: '+995' }, { Name: 'Germany', Code: 'DE', Timezone: 'W. Europe Standard Time', UTC: 'UTC+01:00', MobileCode: '+49' }, { Name: 'Ghana', Code: 'GH', Timezone: 'Greenwich Standard Time', UTC: 'UTC', MobileCode: '+233' }, { Name: 'Gibraltar', Code: 'GI', Timezone: 'W. Europe Standard Time', UTC: 'UTC+01:00', MobileCode: '+350' }, { Name: 'Greece', Code: 'GR', Timezone: 'GTB Standard Time', UTC: 'UTC+02:00', MobileCode: '+30' }, { Name: 'Greenland', Code: 'GL', Timezone: 'Greenland Standard Time', UTC: 'UTC-03:00', MobileCode: '+299' }, { Name: 'Grenada', Code: 'GD', Timezone: 'SA Western Standard Time', UTC: 'UTC-04:00', MobileCode: '+1-473' }, { Name: 'Guadeloupe', Code: 'GP', Timezone: 'SA Western Standard Time', UTC: 'UTC-04:00', MobileCode: '+590' }, { Name: 'Guam', Code: 'GU', Timezone: 'West Pacific Standard Time', UTC: 'UTC+10:00', MobileCode: '+1-671' }, { Name: 'Guatemala', Code: 'GT', Timezone: 'Central America Standard Time', UTC: 'UTC-06:00', MobileCode: '+502' }, { Name: 'Guernsey', Code: 'GG', Timezone: 'GMT Standard Time', UTC: 'UTC', MobileCode: '+44-1481' }, { Name: 'Guinea', Code: 'GN', Timezone: 'Greenwich Standard Time', UTC: 'UTC', MobileCode: '+224' }, { Name: 'Guinea-Bissau', Code: 'GW', Timezone: 'Greenwich Standard Time', UTC: 'UTC', MobileCode: '+245' }, { Name: 'Guyana', Code: 'GY', Timezone: 'SA Western Standard Time', UTC: 'UTC-04:00', MobileCode: '+592' }, { Name: 'Haiti', Code: 'HT', Timezone: 'Eastern Standard Time', UTC: 'UTC-05:00', MobileCode: '+509' }, { Name: 'Heard Island and McDonald Islands', Code: 'HM', Timezone: 'Mauritius Standard Time', UTC: 'UTC+04:00', MobileCode: '+ ' }, { Name: 'Honduras', Code: 'HN', Timezone: 'Central America Standard Time', UTC: 'UTC-06:00', MobileCode: '+504' }, { Name: 'Hong Kong SAR', Code: 'HK', Timezone: 'China Standard Time', UTC: 'UTC+08:00', MobileCode: '+852' }, { Name: 'Hungary', Code: 'HU', Timezone: 'Central Europe Standard Time', UTC: 'UTC+01:00', MobileCode: '+36' }, { Name: 'Iceland', Code: 'IS', Timezone: 'Greenwich Standard Time', UTC: 'UTC', MobileCode: '+354' }, { Name: 'India', Code: 'IN', Timezone: 'India Standard Time', UTC: 'UTC+05:30', MobileCode: '+91' }, { Name: 'Indonesia', Code: 'ID', Timezone: 'SE Asia Standard Time', UTC: 'UTC+07:00', MobileCode: '+62' }, { Name: 'Iran', Code: 'IR', Timezone: 'Iran Standard Time', UTC: 'UTC+03:30', MobileCode: '+98' }, { Name: 'Iraq', Code: 'IQ', Timezone: 'Arabic Standard Time', UTC: 'UTC+03:00', MobileCode: '+964' }, { Name: 'Ireland', Code: 'IE', Timezone: 'GMT Standard Time', UTC: 'UTC', MobileCode: '+353' }, { Name: 'Israel', Code: 'IL', Timezone: 'Israel Standard Time', UTC: 'UTC+02:00', MobileCode: '+972' }, { Name: 'Italy', Code: 'IT', Timezone: 'W. Europe Standard Time', UTC: 'UTC+01:00', MobileCode: '+39' }, { Name: 'Jamaica', Code: 'JM', Timezone: 'SA Pacific Standard Time', UTC: 'UTC-05:00', MobileCode: '+1-876' }, { Name: 'Jan Mayen', Code: 'SJ', Timezone: 'W. Europe Standard Time', UTC: 'UTC+01:00', MobileCode: '+47' }, { Name: 'Japan', Code: 'JP', Timezone: 'Tokyo Standard Time', UTC: 'UTC+09:00', MobileCode: '+81' }, { Name: 'Jersey', Code: 'JE', Timezone: 'GMT Standard Time', UTC: 'UTC', MobileCode: '+44-1534' }, { Name: 'Jordan', Code: 'JO', Timezone: 'Jordan Standard Time', UTC: 'UTC+02:00', MobileCode: '+962' }, { Name: 'Kazakhstan', Code: 'KZ', Timezone: 'Central Asia Standard Time', UTC: 'UTC+06:00', MobileCode: '+7' }, { Name: 'Kenya', Code: 'KE', Timezone: 'E. Africa Standard Time', UTC: 'UTC+03:00', MobileCode: '+254' }, { Name: 'Kiribati', Code: 'KI', Timezone: 'UTC+12', UTC: 'UTC+12:00', MobileCode: '+686' }, { Name: 'Korea', Code: 'KR', Timezone: 'Korea Standard Time', UTC: 'UTC+09:00', MobileCode: '+82' }, { Name: 'Kosovo', Code: 'XK', Timezone: 'Central European Standard Time', UTC: 'UTC+01:00', MobileCode: '+' }, { Name: 'Kuwait', Code: 'KW', Timezone: 'Arab Standard Time', UTC: 'UTC+03:00', MobileCode: '+965' }, { Name: 'Kyrgyzstan', Code: 'KG', Timezone: 'Central Asia Standard Time', UTC: 'UTC+06:00', MobileCode: '+996' }, { Name: 'Laos', Code: 'LA', Timezone: 'SE Asia Standard Time', UTC: 'UTC+07:00', MobileCode: '+856' }, { Name: 'Latvia', Code: 'LV', Timezone: 'FLE Standard Time', UTC: 'UTC+02:00', MobileCode: '+371' }, { Name: 'Lebanon', Code: 'LB', Timezone: 'Middle East Standard Time', UTC: 'UTC+02:00', MobileCode: '+961' }, { Name: 'Lesotho', Code: 'LS', Timezone: 'South Africa Standard Time', UTC: 'UTC+02:00', MobileCode: '+266' }, { Name: 'Liberia', Code: 'LR', Timezone: 'Greenwich Standard Time', UTC: 'UTC', MobileCode: '+231' }, { Name: 'Libya', Code: 'LY', Timezone: 'E. Europe Standard Time', UTC: 'UTC+02:00', MobileCode: '+218' }, { Name: 'Liechtenstein', Code: 'LI', Timezone: 'W. Europe Standard Time', UTC: 'UTC+01:00', MobileCode: '+423' }, { Name: 'Lithuania', Code: 'LT', Timezone: 'FLE Standard Time', UTC: 'UTC+02:00', MobileCode: '+370' }, { Name: 'Luxembourg', Code: 'LU', Timezone: 'W. Europe Standard Time', UTC: 'UTC+01:00', MobileCode: '+352' }, { Name: 'Macao SAR', Code: 'MO', Timezone: 'China Standard Time', UTC: 'UTC+08:00', MobileCode: '+853' }, { Name: 'Macedonia, Former Yugoslav Republic of', Code: 'MK', Timezone: 'Central European Standard Time', UTC: 'UTC+01:00', MobileCode: '+389' }, { Name: 'Madagascar', Code: 'MG', Timezone: 'E. Africa Standard Time', UTC: 'UTC+03:00', MobileCode: '+261' }, { Name: 'Malawi', Code: 'MW', Timezone: 'South Africa Standard Time', UTC: 'UTC+02:00', MobileCode: '+265' }, { Name: 'Malaysia', Code: 'MY', Timezone: 'Singapore Standard Time', UTC: 'UTC+08:00', MobileCode: '+60' }, { Name: 'Maldives', Code: 'MV', Timezone: 'West Asia Standard Time', UTC: 'UTC+05:00', MobileCode: '+960' }, { Name: 'Mali', Code: 'ML', Timezone: 'Greenwich Standard Time', UTC: 'UTC', MobileCode: '+223' }, { Name: 'Malta', Code: 'MT', Timezone: 'W. Europe Standard Time', UTC: 'UTC+01:00', MobileCode: '+356' }, { Name: 'Man, Isle of', Code: 'IM', Timezone: 'GMT Standard Time', UTC: 'UTC', MobileCode: '+44-1624' }, { Name: 'Marshall Islands', Code: 'MH', Timezone: 'UTC+12', UTC: 'UTC+12:00', MobileCode: '+692' }, { Name: 'Martinique', Code: 'MQ', Timezone: 'SA Western Standard Time', UTC: 'UTC-04:00', MobileCode: '+596' }, { Name: 'Mauritania', Code: 'MR', Timezone: 'Greenwich Standard Time', UTC: 'UTC', MobileCode: '+222' }, { Name: 'Mauritius', Code: 'MU', Timezone: 'Mauritius Standard Time', UTC: 'UTC+04:00', MobileCode: '+230' }, { Name: 'Mayotte', Code: 'YT', Timezone: 'E. Africa Standard Time', UTC: 'UTC+03:00', MobileCode: '+262' }, { Name: 'Mexico', Code: 'MX', Timezone: 'Central Standard Time (Mexico)', UTC: 'UTC-06:00', MobileCode: '+52' }, { Name: 'Micronesia', Code: 'FM', Timezone: 'West Pacific Standard Time', UTC: 'UTC+10:00', MobileCode: '+691' }, { Name: 'Moldova', Code: 'MD', Timezone: 'GTB Standard Time', UTC: 'UTC+02:00', MobileCode: '+373' }, { Name: 'Monaco', Code: 'MC', Timezone: 'W. Europe Standard Time', UTC: 'UTC+01:00', MobileCode: '+377' }, { Name: 'Mongolia', Code: 'MN', Timezone: 'Ulaanbaatar Standard Time', UTC: 'UTC+08:00', MobileCode: '+976' }, { Name: 'Montenegro', Code: 'ME', Timezone: 'Central European Standard Time', UTC: 'UTC+01:00', MobileCode: '+382' }, { Name: 'Montserrat', Code: 'MS', Timezone: 'SA Western Standard Time', UTC: 'UTC-04:00', MobileCode: '+1-664' }, { Name: 'Morocco', Code: 'MA', Timezone: 'Morocco Standard Time', UTC: 'UTC', MobileCode: '+212' }, { Name: 'Mozambique', Code: 'MZ', Timezone: 'South Africa Standard Time', UTC: 'UTC+02:00', MobileCode: '+258' }, { Name: 'Myanmar', Code: 'MM', Timezone: 'Myanmar Standard Time', UTC: 'UTC+06:30', MobileCode: '+95' }, { Name: 'Namibia', Code: 'NA', Timezone: 'Namibia Standard Time', UTC: 'UTC+01:00', MobileCode: '+264' }, { Name: 'Nauru', Code: 'NR', Timezone: 'UTC+12', UTC: 'UTC+12:00', MobileCode: '+674' }, { Name: 'Nepal', Code: 'NP', Timezone: 'Nepal Standard Time', UTC: 'UTC+05:45', MobileCode: '+977' }, { Name: 'Netherlands', Code: 'NL', Timezone: 'W. Europe Standard Time', UTC: 'UTC+01:00', MobileCode: '+31' }, { Name: 'New Caledonia', Code: 'NC', Timezone: 'Central Pacific Standard Time', UTC: 'UTC+11:00', MobileCode: '+687' }, { Name: 'New Zealand', Code: 'NZ', Timezone: 'New Zealand Standard Time', UTC: 'UTC+12:00', MobileCode: '+64' }, { Name: 'Nicaragua', Code: 'NI', Timezone: 'Central America Standard Time', UTC: 'UTC-06:00', MobileCode: '+505' }, { Name: 'Niger', Code: 'NE', Timezone: 'W. Central Africa Standard Time', UTC: 'UTC+01:00', MobileCode: '+227' }, { Name: 'Nigeria', Code: 'NG', Timezone: 'W. Central Africa Standard Time', UTC: 'UTC+01:00', MobileCode: '+234' }, { Name: 'Niue', Code: 'NU', Timezone: 'UTC-11', UTC: 'UTC-11:00', MobileCode: '+683' }, { Name: 'Norfolk Island', Code: 'NF', Timezone: 'Central Pacific Standard Time', UTC: 'UTC+11:00', MobileCode: '+672' }, { Name: 'North Korea', Code: 'KP', Timezone: 'Korea Standard Time', UTC: 'UTC+09:00', MobileCode: '+850' }, { Name: 'Northern Mariana Islands', Code: 'MP', Timezone: 'West Pacific Standard Time', UTC: 'UTC+10:00', MobileCode: '+1-670' }, { Name: 'Norway', Code: 'NO', Timezone: 'W. Europe Standard Time', UTC: 'UTC+01:00', MobileCode: '+47' }, { Name: 'Oman', Code: 'OM', Timezone: 'Arabian Standard Time', UTC: 'UTC+04:00', MobileCode: '+968' }, { Name: 'Pakistan', Code: 'PK', Timezone: 'Pakistan Standard Time', UTC: 'UTC+05:00', MobileCode: '+92' }, { Name: 'Palau', Code: 'PW', Timezone: 'Tokyo Standard Time', UTC: 'UTC+09:00', MobileCode: '+680' }, { Name: 'Palestinian Authority', Code: 'PS', Timezone: 'Egypt Standard Time', UTC: 'UTC+02:00', MobileCode: '+970' }, { Name: 'Panama', Code: 'PA', Timezone: 'SA Pacific Standard Time', UTC: 'UTC-05:00', MobileCode: '+507' }, { Name: 'Papua New Guinea', Code: 'PG', Timezone: 'West Pacific Standard Time', UTC: 'UTC+10:00', MobileCode: '+675' }, { Name: 'Paraguay', Code: 'PY', Timezone: 'Paraguay Standard Time', UTC: 'UTC-04:00', MobileCode: '+595' }, { Name: 'Peru', Code: 'PE', Timezone: 'SA Pacific Standard Time', UTC: 'UTC-05:00', MobileCode: '+51' }, { Name: 'Philippines', Code: 'PH', Timezone: 'Singapore Standard Time', UTC: 'UTC+08:00', MobileCode: '+63' }, { Name: 'Pitcairn Islands', Code: 'PN', Timezone: 'Pacific Standard Time', UTC: 'UTC-08:00', MobileCode: '+870' }, { Name: 'Poland', Code: 'PL', Timezone: 'Central European Standard Time', UTC: 'UTC+01:00', MobileCode: '+48' }, { Name: 'Portugal', Code: 'PT', Timezone: 'GMT Standard Time', UTC: 'UTC', MobileCode: '+351' }, { Name: 'Puerto Rico', Code: 'PR', Timezone: 'SA Western Standard Time', UTC: 'UTC-04:00', MobileCode: '+1-787 and 1-939' }, { Name: 'Qatar', Code: 'QA', Timezone: 'Arab Standard Time', UTC: 'UTC+03:00', MobileCode: '+974' }, { Name: 'Reunion', Code: 'RE', Timezone: 'Mauritius Standard Time', UTC: 'UTC+04:00', MobileCode: '+262' }, { Name: 'Romania', Code: 'RO', Timezone: 'GTB Standard Time', UTC: 'UTC+02:00', MobileCode: '+40' }, { Name: 'Russia', Code: 'RU', Timezone: 'Russian Standard Time', UTC: 'UTC+03:00', MobileCode: '+7' }, { Name: 'Rwanda', Code: 'RW', Timezone: 'South Africa Standard Time', UTC: 'UTC+02:00', MobileCode: '+250' }, { Name: 'Saint Barthélemy', Code: 'BL', Timezone: 'SA Western Standard Time', UTC: 'UTC-04:00', MobileCode: '+590' }, { Name: 'Saint Helena, Ascension and Tristan da Cunha', Code: 'SH', Timezone: 'Greenwich Standard Time', UTC: 'UTC', MobileCode: '+290' }, { Name: 'Saint Kitts and Nevis', Code: 'KN', Timezone: 'SA Western Standard Time', UTC: 'UTC-04:00', MobileCode: '+1-869' }, { Name: 'Saint Lucia', Code: 'LC', Timezone: 'SA Western Standard Time', UTC: 'UTC-04:00', MobileCode: '+1-758' }, { Name: 'Saint Martin (French part)', Code: 'MF', Timezone: 'SA Western Standard Time', UTC: 'UTC-04:00', MobileCode: '+590' }, { Name: 'Saint Pierre and Miquelon', Code: 'PM', Timezone: 'Greenland Standard Time', UTC: 'UTC-03:00', MobileCode: '+508' }, { Name: 'Saint Vincent and the Grenadines', Code: 'VC', Timezone: 'SA Western Standard Time', UTC: 'UTC-04:00', MobileCode: '+1-784' }, { Name: 'Samoa', Code: 'WS', Timezone: 'Samoa Standard Time', UTC: 'UTC+13:00', MobileCode: '+685' }, { Name: 'San Marino', Code: 'SM', Timezone: 'W. Europe Standard Time', UTC: 'UTC+01:00', MobileCode: '+378' }, { Name: 'São Tomé and Príncipe', Code: 'ST', Timezone: 'Greenwich Standard Time', UTC: 'UTC', MobileCode: '+239' }, { Name: 'Saudi Arabia', Code: 'SA', Timezone: 'Arab Standard Time', UTC: 'UTC+03:00', MobileCode: '+966' }, { Name: 'Senegal', Code: 'SN', Timezone: 'Greenwich Standard Time', UTC: 'UTC', MobileCode: '+221' }, { Name: 'Serbia', Code: 'RS', Timezone: 'Central Europe Standard Time', UTC: 'UTC+01:00', MobileCode: '+381' }, { Name: 'Seychelles', Code: 'SC', Timezone: 'Mauritius Standard Time', UTC: 'UTC+04:00', MobileCode: '+248' }, { Name: 'Sierra Leone', Code: 'SL', Timezone: 'Greenwich Standard Time', UTC: 'UTC', MobileCode: '+232' }, { Name: 'Singapore', Code: 'SG', Timezone: 'Singapore Standard Time', UTC: 'UTC+08:00', MobileCode: '+65' }, { Name: 'Sint Maarten (Dutch part)', Code: 'SX', Timezone: 'SA Western Standard Time', UTC: 'UTC-04:00', MobileCode: '+599' }, { Name: 'Slovakia', Code: 'SK', Timezone: 'Central Europe Standard Time', UTC: 'UTC+01:00', MobileCode: '+421' }, { Name: 'Slovenia', Code: 'SI', Timezone: 'Central Europe Standard Time', UTC: 'UTC+01:00', MobileCode: '+386' }, { Name: 'Solomon Islands', Code: 'SB', Timezone: 'Central Pacific Standard Time', UTC: 'UTC+11:00', MobileCode: '+677' }, { Name: 'Somalia', Code: 'SO', Timezone: 'E. Africa Standard Time', UTC: 'UTC+03:00', MobileCode: '+252' }, { Name: 'South Africa', Code: 'ZA', Timezone: 'South Africa Standard Time', UTC: 'UTC+02:00', MobileCode: '+27' }, { Name: 'South Georgia and the South Sandwich Islands', Code: 'GS', Timezone: 'UTC-02', UTC: 'UTC-02:00', MobileCode: '+' }, { Name: 'South Sudan', Code: 'SS', Timezone: 'E. Africa Standard Time', UTC: 'UTC+03:00', MobileCode: '+211' }, { Name: 'Spain', Code: 'ES', Timezone: 'Romance Standard Time', UTC: 'UTC+01:00', MobileCode: '+34' }, { Name: 'Sri Lanka', Code: 'LK', Timezone: 'Sri Lanka Standard Time', UTC: 'UTC+05:30', MobileCode: '+94' }, { Name: 'Sudan', Code: 'SD', Timezone: 'E. Africa Standard Time', UTC: 'UTC+03:00', MobileCode: '+249' }, { Name: 'Suriname', Code: 'SR', Timezone: 'SA Eastern Standard Time', UTC: 'UTC-03:00', MobileCode: '+597' }, { Name: 'Svalbard', Code: 'SJ', Timezone: 'W. Europe Standard Time', UTC: 'UTC+01:00', MobileCode: '+47' }, { Name: 'Swaziland', Code: 'SZ', Timezone: 'South Africa Standard Time', UTC: 'UTC+02:00', MobileCode: '+268' }, { Name: 'Sweden', Code: 'SE', Timezone: 'W. Europe Standard Time', UTC: 'UTC+01:00', MobileCode: '+46' }, { Name: 'Switzerland', Code: 'CH', Timezone: 'W. Europe Standard Time', UTC: 'UTC+01:00', MobileCode: '+41' }, { Name: 'Syria', Code: 'SY', Timezone: 'Syria Standard Time', UTC: 'UTC+02:00', MobileCode: '+963' }, { Name: 'Taiwan', Code: 'TW', Timezone: 'Taipei Standard Time', UTC: 'UTC+08:00', MobileCode: '+886' }, { Name: 'Tajikistan', Code: 'TJ', Timezone: 'West Asia Standard Time', UTC: 'UTC+05:00', MobileCode: '+992' }, { Name: 'Tanzania', Code: 'TZ', Timezone: 'E. Africa Standard Time', UTC: 'UTC+03:00', MobileCode: '+255' }, { Name: 'Thailand', Code: 'TH', Timezone: 'SE Asia Standard Time', UTC: 'UTC+07:00', MobileCode: '+66' }, { Name: 'Togo', Code: 'TG', Timezone: 'Greenwich Standard Time', UTC: 'UTC', MobileCode: '+228' }, { Name: 'Tokelau', Code: 'TK', Timezone: 'Tonga Standard Time', UTC: 'UTC+13:00', MobileCode: '+690' }, { Name: 'Tonga', Code: 'TO', Timezone: 'Tonga Standard Time', UTC: 'UTC+13:00', MobileCode: '+676' }, { Name: 'Trinidad and Tobago', Code: 'TT', Timezone: 'SA Western Standard Time', UTC: 'UTC-04:00', MobileCode: '+1-868' }, { Name: 'Tunisia', Code: 'TN', Timezone: 'W. Central Africa Standard Time', UTC: 'UTC+01:00', MobileCode: '+216' }, { Name: 'Turkey', Code: 'TR', Timezone: 'Turkey Standard Time', UTC: 'UTC+02:00', MobileCode: '+90' }, { Name: 'Turkmenistan', Code: 'TM', Timezone: 'West Asia Standard Time', UTC: 'UTC+05:00', MobileCode: '+993' }, { Name: 'Turks and Caicos Islands', Code: 'TC', Timezone: 'Eastern Standard Time', UTC: 'UTC-05:00', MobileCode: '+1-649' }, { Name: 'Tuvalu', Code: 'TV', Timezone: 'UTC+12', UTC: 'UTC+12:00', MobileCode: '+688' }, { Name: 'U.S. Minor Outlying Islands', Code: 'UM', Timezone: 'UTC-11', UTC: 'UTC-11:00', MobileCode: '+1' }, { Name: 'Uganda', Code: 'UG', Timezone: 'E. Africa Standard Time', UTC: 'UTC+03:00', MobileCode: '+256' }, { Name: 'Ukraine', Code: 'UA', Timezone: 'FLE Standard Time', UTC: 'UTC+02:00', MobileCode: '+380' }, { Name: 'United Arab Emirates', Code: 'AE', Timezone: 'Arabian Standard Time', UTC: 'UTC+04:00', MobileCode: '+971' }, { Name: 'United Kingdom', Code: 'GB', Timezone: 'GMT Standard Time', UTC: 'UTC', MobileCode: '+44' }, { Name: 'United States', Code: 'US', Timezone: 'Pacific Standard Time', UTC: 'UTC-08:00', MobileCode: '+1' }, { Name: 'Uruguay', Code: 'UY', Timezone: 'Montevideo Standard Time', UTC: 'UTC-03:00', MobileCode: '+598' }, { Name: 'Uzbekistan', Code: 'UZ', Timezone: 'West Asia Standard Time', UTC: 'UTC+05:00', MobileCode: '+998' }, { Name: 'Vanuatu', Code: 'VU', Timezone: 'Central Pacific Standard Time', UTC: 'UTC+11:00', MobileCode: '+678' }, { Name: 'Vatican City', Code: 'VA', Timezone: 'W. Europe Standard Time', UTC: 'UTC+01:00', MobileCode: '+379' }, { Name: 'Vietnam', Code: 'VN', Timezone: 'SE Asia Standard Time', UTC: 'UTC+07:00', MobileCode: '+84' }, { Name: 'Virgin Islands, U.S.', Code: 'VI', Timezone: 'SA Western Standard Time', UTC: 'UTC-04:00', MobileCode: '+1-340' }, { Name: 'Virgin Islands, British', Code: 'VG', Timezone: 'SA Western Standard Time', UTC: 'UTC-04:00', MobileCode: '+1-284' }, { Name: 'Wallis and Futuna', Code: 'WF', Timezone: 'UTC+12', UTC: 'UTC+12:00', MobileCode: '+681' }, { Name: 'Yemen', Code: 'YE', Timezone: 'Arab Standard Time', UTC: 'UTC+03:00', MobileCode: '+967' }, { Name: 'Zambia', Code: 'ZM', Timezone: 'South Africa Standard Time', UTC: 'UTC+02:00', MobileCode: '+260' }, { Name: 'Zimbabwe', Code: 'ZW', Timezone: 'South Africa Standard Time', UTC: 'UTC+02:00', MobileCode: '+263' }];